import axios from 'axios'
import { getToken } from '@/utils/auth'

const http = axios.create({
  baseURL: '/api',
  timeout: 30000
})

let unauthorizedHandler = null

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler
}

http.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  response => response.data,
  error => {
    const status = error.response && error.response.status
    const payload = error.response && error.response.data
    const isUnauthorized = status === 401 ||
      (payload && (payload.code === 401 || payload.status === 401))

    if (isUnauthorized && typeof unauthorizedHandler === 'function') {
      unauthorizedHandler()
    }

    return Promise.reject(error)
  }
)

export default http
